import { render, staticRenderFns } from "./PersistEnderecoView.vue?vue&type=template&id=8b7e7010&"
import script from "./PersistEnderecoView.vue?vue&type=script&lang=ts&"
export * from "./PersistEnderecoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports